import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LogoMain from "../../../assets/images/altruist_logo.png";
import { VerifyEmail } from "../../../api/Api"; // You'll need to create this API function

export default function EmailVerification() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
    try {
      const response = await VerifyEmail({ token });
      setVerifying(false);
      
      if (response?.data?.statusDescription?.status === 200) {
        Swal.fire({
          text: "Email verified successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/"); 
        });
      } else {
        Swal.fire({
          text: "Invalid or expired verification link",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/");
        });
      }
    } catch (error) {
      setVerifying(false);
      Swal.fire({
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/");
      });
    }
  };

  return (
    <div className="bg_image align-items-left min-vh-100">
      <div className="container my-auto">
        <div className="login-box">
          <div className="login-logo">
            <img src={LogoMain} alt="logo" width="123px" />
          </div>
          <div className="login-box-body text-center">
            {verifying ? (
              <>
                <p className="mb-3">Verifying your email...</p>
                <i className="fa fa-spinner fa-spin fa-2x"></i>
              </>
            ) : (
              <p className="mb-3">Please wait...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
} 